import {
  MYPOINT_TYPE_LIST,
  MYPOINT_STATUS_LIST,
  MYPOINT_LIST,
  USER_SIKDAE_LIST,
  USER_SIKDAE_TOTAL,
  USER_SIKDAE_DETAIL,
  STATS_STORE,
  STATS_DIVISION,
  STATS_GROUP,
  STATS_USAGE,
  STATS_USAGE_TOTAL,
  SIKDAE_DETAIL_LIST,
  SIKDAE_DETAIL_DETAIL,
  SIKDAE_DETAIL_LIST_DOWNLOAD,
  BILL_DETAIL,
  BILL_GROUP_LIST,
  BILL_DATE_LIST,
  BILL_ACCEPTED,
  BILL_REJECTED,
  BILL_PARENT_REJECTED,
  BILL_DET_LIST,
  BILL_DET_TOTAL,
  BILL_APPROVAL_STEP_LIST,
  BILL_APPROVAL_STEP_MOD,
  BILL_RETURN_STEP_MOD,
  OURHOME_SUBTRACT_STATS_LIST,
  DEDUCTION_SAMSUNGCARD_STATS_USAGE,
  DEDUCTION_SAMSUNGCARD_STATS_USAGE_TOTAL,
  DEDUCTION_SAMSUNGCNT_STATS_USAGE,
  DEDUCTION_WELCOME_SYSTEM_INC_STATS_USAGE,
  DEDUCTION_SAMSUNGMEDICAL_STATS_USAGE,
  DEDUCTION_KIMANDCHANG_STATS_USAGE,
  INITIALIZE_USAGE_STATS,
  USER_SIKDAE_USAGE_LIST,
  USER_SIKDAE_USAGE_TOTAL,
  USER_SIKDAE_USAGE_DETAIL,
  CLEAN_USER_SIKDAE_USAGE,
  CLEAN_USER_SIKDAE_GIVEN,
  USER_SIKDAE_GRAND_DEDUCT_LIST,
  UserSikdaeGrandDeductHistory,
  USER_SIKDAE_GRAND_DEDUCT_TOTAL,
  USER_SIKDAE_GRAND_DEDUCT_DETAIL,
  CLEAN_USER_SIKDAE_GRAND_DEDUCT,
  SIKDAE_DETAIL_EXCEL_LIST,
  BARCODE_MEMBER,
  BARCODE_HISTORIES,
  BARCODE_CREATE_BULK
} from 'actions/usage';

function usage(state = {}, action) {
  const { payload } = action;

  switch (action.type) {
    case `${MYPOINT_TYPE_LIST}_FULFILLED`:
      return {
        ...state,
        pointTypeList: payload
      };
    case `${MYPOINT_TYPE_LIST}_PENDING`:
      return {
        ...state,
        pointTypeList: payload
      };
    case `${MYPOINT_TYPE_LIST}_REJECTED`:
      return {
        ...state,
        pointTypeList: payload
      };

    case `${MYPOINT_STATUS_LIST}_FULFILLED`:
      return {
        ...state,
        pointStatusList: payload
      };
    case `${MYPOINT_STATUS_LIST}_PENDING`:
      return {
        ...state,
        pointStatusList: payload
      };
    case `${MYPOINT_STATUS_LIST}_REJECTED`:
      return {
        ...state,
        pointStatusList: payload
      };

    case `${MYPOINT_LIST}_FULFILLED`:
      return {
        ...state,
        pointList: payload
      };
    case `${MYPOINT_LIST}_PENDING`:
      return {
        ...state,
        pointList: payload
      };
    case `${MYPOINT_LIST}_REJECTED`:
      return {
        ...state,
        pointList: payload
      };

    case `${USER_SIKDAE_LIST}_FULFILLED`:
      return {
        ...state,
        userSikdaeList: payload
      };
    case `${USER_SIKDAE_LIST}_PENDING`:
      return {
        ...state,
        userSikdaeList: payload
      };
    case `${USER_SIKDAE_LIST}_REJECTED`:
      return {
        ...state,
        userSikdaeList: payload
      };

    case `${USER_SIKDAE_TOTAL}_FULFILLED`:
      return {
        ...state,
        userSikdaeTotal: payload
      };

    case `${USER_SIKDAE_TOTAL}_PENDING`:
      return {
        ...state,
        userSikdaeTotal: payload
      };

    case `${USER_SIKDAE_TOTAL}_REJECTED`:
      return {
        ...state,
        userSikdaeTotal: payload
      };

    case `${USER_SIKDAE_DETAIL}_FULFILLED`:
      return {
        ...state,
        userSikDetail: payload
      };
    case `${USER_SIKDAE_DETAIL}_PENDING`:
      return {
        ...state,
        userSikDetail: payload
      };
    case `${USER_SIKDAE_DETAIL}_REJECTED`:
      return {
        ...state,
        userSikDetail: payload
      };
    case `${USER_SIKDAE_USAGE_LIST}_FULFILLED`:
      return {
        ...state,
        userSikdaeUsageHistory: payload
      };
    case `${USER_SIKDAE_USAGE_LIST}_PENDING`:
      return {
        ...state,
        userSikdaeUsageHistory: payload
      };
    case `${USER_SIKDAE_USAGE_LIST}_REJECTED`:
      return {
        ...state,
        userSikdaeUsageHistory: payload
      };
    case `${USER_SIKDAE_USAGE_TOTAL}_FULFILLED`:
      return {
        ...state,
        userSikdaeUsageTotal: payload
      };
    case `${USER_SIKDAE_USAGE_TOTAL}_PENDING`:
      return {
        ...state,
        userSikdaeUsageTotal: payload
      };
    case `${USER_SIKDAE_USAGE_TOTAL}_REJECTED`:
      return {
        ...state,
        userSikdaeUsageTotal: payload
      };
    case `${USER_SIKDAE_USAGE_DETAIL}_FULFILLED`:
      return {
        ...state,
        userSikdaeUsageDetail: payload
      };
    case `${USER_SIKDAE_USAGE_DETAIL}_PENDING`:
      return {
        ...state,
        userSikdaeUsageDetail: payload
      };
    case `${USER_SIKDAE_USAGE_DETAIL}_REJECTED`:
      return {
        ...state,
        userSikdaeUsageDetail: payload
      };
    case `${CLEAN_USER_SIKDAE_USAGE}`:
      return {
        ...state,
        userSikdaeUsageHistory: {},
        userSikdaeUsageTotal: {}
      };
    case `${CLEAN_USER_SIKDAE_GIVEN}`:
      return {
        ...state,
        userSikdaeList: {},
        userSikdaeTotal: {}
      };
    // 사용자별 지급/차감 내역
    case `${USER_SIKDAE_GRAND_DEDUCT_LIST}_FULFILLED`:
      return {
        ...state,
        userSikdaeGrandDeductHistory: payload
      };
    case `${USER_SIKDAE_GRAND_DEDUCT_LIST}_PENDING`:
      return {
        ...state,
        userSikdaeGrandDeductHistory: payload
      };
    case `${USER_SIKDAE_GRAND_DEDUCT_LIST}_REJECTED`:
      return {
        ...state,
        userSikdaeGrandDeductHistory: payload
      };
    // 사용자별 지급/차감 합계
    case `${USER_SIKDAE_GRAND_DEDUCT_TOTAL}_FULFILLED`:
      return {
        ...state,
        userSikdaeGrandDeductTotal: payload
      };
    case `${USER_SIKDAE_GRAND_DEDUCT_TOTAL}_PENDING`:
      return {
        ...state,
        userSikdaeGrandDeductTotal: payload
      };
    case `${USER_SIKDAE_GRAND_DEDUCT_TOTAL}_REJECTED`:
      return {
        ...state,
        userSikdaeGrandDeductTotal: payload
      };
    // 사용자별 지급/차감 상세
    case `${USER_SIKDAE_GRAND_DEDUCT_DETAIL}_FULFILLED`:
      return {
        ...state,
        userSikdaeGrandDeductDetail: payload
      };
    case `${USER_SIKDAE_GRAND_DEDUCT_DETAIL}_PENDING`:
      return {
        ...state,
        userSikdaeGrandDeductDetail: payload
      };
    case `${USER_SIKDAE_GRAND_DEDUCT_DETAIL}_REJECTED`:
      return {
        ...state,
        userSikdaeGrandDeductDetail: payload
      };
    case `${CLEAN_USER_SIKDAE_GRAND_DEDUCT}`:
      return {
        ...state,
        userSikdaeGrandDeductHistory: {},
        userSikdaeGrandDeductTotal: {}
      };
    case `${STATS_STORE}_FULFILLED`:
      return {
        ...state,
        storeStats: payload
      };
    case `${STATS_STORE}_PENDING`:
      return {
        ...state,
        storeStats: payload
      };
    case `${STATS_STORE}_REJECTED`:
      return {
        ...state,
        storeStats: payload
      };

    case `${STATS_DIVISION}_FULFILLED`:
      return {
        ...state,
        divisionStats: payload
      };
    case `${STATS_DIVISION}_PENDING`:
      return {
        ...state,
        divisionStats: payload
      };
    case `${STATS_DIVISION}_REJECTED`:
      return {
        ...state,
        divisionStats: payload
      };

    case `${STATS_GROUP}_FULFILLED`:
      return {
        ...state,
        groupStats: payload
      };
    case `${STATS_GROUP}_PENDING`:
      return {
        ...state,
        groupStats: payload
      };
    case `${STATS_GROUP}_REJECTED`:
      return {
        ...state,
        groupStats: payload
      };

    case `${STATS_USAGE}_FULFILLED`:
      return {
        ...state,
        usageStats: payload
      };
    case `${STATS_USAGE}_PENDING`:
      return {
        ...state,
        usageStats: payload
      };
    case `${STATS_USAGE}_REJECTED`:
      return {
        ...state,
        usageStats: payload
      };

    case `${STATS_USAGE_TOTAL}_FULFILLED`:
      return {
        ...state,
        usageStatsTotal: payload
      };

    case `${STATS_USAGE_TOTAL}_PENDING`:
      return {
        ...state,
        usageStatsTotal: payload
      };

    case `${STATS_USAGE_TOTAL}_REJECTED`:
      return {
        ...state,
        usageStatsTotal: payload
      };

    case `${DEDUCTION_SAMSUNGCNT_STATS_USAGE}_FULFILLED`:
      return {
        ...state,
        usageStats: payload,
        usageStatsTotal: payload
      };

    case `${DEDUCTION_SAMSUNGCNT_STATS_USAGE}_PENDING`:
      return {
        ...state,
        usageStats: payload,
        usageStatsTotal: payload
      };

    case `${DEDUCTION_SAMSUNGCNT_STATS_USAGE}_REJECTED`:
      return {
        ...state,
        usageStats: payload,
        usageStatsTotal: payload
      };

    case `${DEDUCTION_SAMSUNGCARD_STATS_USAGE}_FULFILLED`:
      return {
        ...state,
        usageStats: payload
      };

    case `${DEDUCTION_SAMSUNGCARD_STATS_USAGE}_PENDING`:
      return {
        ...state,
        usageStats: payload
      };

    case `${DEDUCTION_SAMSUNGCARD_STATS_USAGE}_REJECTED`:
      return {
        ...state,
        usageStats: payload
      };

    case `${DEDUCTION_SAMSUNGCARD_STATS_USAGE_TOTAL}_FULFILLED`:
      return {
        ...state,
        usageStatsTotal: payload
      };

    case `${DEDUCTION_SAMSUNGCARD_STATS_USAGE_TOTAL}_PENDING`:
      return {
        ...state,
        usageStatsTotal: payload
      };

    case `${DEDUCTION_SAMSUNGCARD_STATS_USAGE_TOTAL}_REJECTED`:
      return {
        ...state,
        usageStatsTotal: payload
      };
    case `${DEDUCTION_WELCOME_SYSTEM_INC_STATS_USAGE}_FULFILLED`:
      return {
        ...state,
        usageStats: payload,
        usageStatsTotal: payload
      };

    case `${DEDUCTION_WELCOME_SYSTEM_INC_STATS_USAGE}_PENDING`:
      return {
        ...state,
        usageStats: payload,
        usageStatsTotal: payload
      };

    case `${DEDUCTION_WELCOME_SYSTEM_INC_STATS_USAGE}_REJECTED`:
      return {
        ...state,
        usageStats: payload,
        usageStatsTotal: payload
      };

    case `${DEDUCTION_SAMSUNGMEDICAL_STATS_USAGE}_FULFILLED`:
      return {
        ...state,
        usageStats: payload,
        usageStatsTotal: payload
      };

    case `${DEDUCTION_SAMSUNGMEDICAL_STATS_USAGE}_PENDING`:
      return {
        ...state,
        usageStats: payload,
        usageStatsTotal: payload
      };

    case `${DEDUCTION_SAMSUNGMEDICAL_STATS_USAGE}_REJECTED`:
      return {
        ...state,
        usageStats: payload,
        usageStatsTotal: payload
      };

    case `${DEDUCTION_KIMANDCHANG_STATS_USAGE}_FULFILLED`:
      return {
        ...state,
        usageStats: payload,
        usageStatsTotal: payload
      };

    case `${DEDUCTION_KIMANDCHANG_STATS_USAGE}_PENDING`:
      return {
        ...state,
        usageStats: payload,
        usageStatsTotal: payload
      };

    case `${DEDUCTION_KIMANDCHANG_STATS_USAGE}_REJECTED`:
      return {
        ...state,
        usageStats: payload,
        usageStatsTotal: payload
      };

    case `${SIKDAE_DETAIL_LIST}_FULFILLED`:
      return {
        ...state,
        detailList: payload
      };
    case `${SIKDAE_DETAIL_LIST}_PENDING`:
      return {
        ...state,
        detailList: payload
      };
    case `${SIKDAE_DETAIL_LIST}_REJECTED`:
      return {
        ...state,
        detailList: payload
      };
    // 엑셀용 식대 상세 조회
    case `${SIKDAE_DETAIL_EXCEL_LIST}_FULFILLED`:
      return {
        ...state,
        detailExcelList: payload
      };
    case `${SIKDAE_DETAIL_EXCEL_LIST}_PENDING`:
      return {
        ...state,
        detailExcelList: payload
      };
    case `${SIKDAE_DETAIL_EXCEL_LIST}_REJECTED`:
      return {
        ...state,
        detailExcelList: payload
      };

    case `${SIKDAE_DETAIL_DETAIL}_FULFILLED`:
      return {
        ...state,
        listDetail: payload
      };
    case `${SIKDAE_DETAIL_DETAIL}_PENDING`:
      return {
        ...state,
        listDetail: payload
      };
    case `${SIKDAE_DETAIL_DETAIL}_REJECTED`:
      return {
        ...state,
        listDetail: payload
      };

    case `${SIKDAE_DETAIL_LIST_DOWNLOAD}_FULFILLED`:
      return {
        ...state,
        detailDownload: payload
      };
    case `${SIKDAE_DETAIL_LIST_DOWNLOAD}_PENDING`:
      return {
        ...state,
        detailDownload: payload
      };
    case `${SIKDAE_DETAIL_LIST_DOWNLOAD}_REJECTED`:
      return {
        ...state,
        detailDownload: payload
      };

    case `${BILL_DETAIL}_FULFILLED`:
      return {
        ...state,
        billDtl: payload
      };

    case `${BILL_DETAIL}_PENDING`:
      return {
        ...state,
        billDtl: payload
      };

    case `${BILL_DETAIL}_REJECTED`:
      return {
        ...state,
        billDtl: payload
      };

    case `${BILL_ACCEPTED}_FULFILLED`:
      return {
        ...state,
        billAccepted: payload
      };

    case `${BILL_ACCEPTED}_PENDING`:
      return {
        ...state,
        billAccepted: payload
      };

    case `${BILL_ACCEPTED}_REJECTED`:
      return {
        ...state,
        billAccepted: payload
      };

    case `${BILL_REJECTED}_FULFILLED`:
      return {
        ...state,
        billRejected: payload
      };

    case `${BILL_REJECTED}_PENDING`:
      return {
        ...state,
        billRejected: payload
      };

    case `${BILL_REJECTED}_REJECTED`:
      return {
        ...state,
        billRejected: payload
      };

    case `${BILL_PARENT_REJECTED}_FULFILLED`:
      return {
        ...state,
        billParentRejected: payload
      };

    case `${BILL_PARENT_REJECTED}_PENDING`:
      return {
        ...state,
        billParentRejected: payload
      };

    case `${BILL_PARENT_REJECTED}_REJECTED`:
      return {
        ...state,
        billParentRejected: payload
      };

    case `${BILL_GROUP_LIST}_FULFILLED`:
      return {
        ...state,
        billGroupList: payload
      };

    case `${BILL_GROUP_LIST}_PENDING`:
      return {
        ...state,
        billGroupList: payload
      };

    case `${BILL_GROUP_LIST}_REJECTED`:
      return {
        ...state,
        billGroupList: payload
      };
    case `${BILL_DATE_LIST}_FULFILLED`:
      return {
        ...state,
        billDateList: payload
      };

    case `${BILL_DATE_LIST}_PENDING`:
      return {
        ...state,
        billDateList: payload
      };

    case `${BILL_DATE_LIST}_REJECTED`:
      return {
        ...state,
        billDateList: payload
      };

    case `${BILL_DET_LIST}_FULFILLED`:
      return {
        ...state,
        billDetList: payload
      };

    case `${BILL_DET_LIST}_PENDING`:
      return {
        ...state,
        billDetList: payload
      };

    case `${BILL_DET_LIST}_REJECTED`:
      return {
        ...state,
        billDetList: payload
      };

    case `${BILL_DET_TOTAL}_FULFILLED`:
      return {
        ...state,
        billDetTotal: payload
      };

    case `${BILL_DET_TOTAL}_PENDING`:
      return {
        ...state,
        billDetTotal: payload
      };

    case `${BILL_DET_TOTAL}_REJECTED`:
      return {
        ...state,
        billDetTotal: payload
      };

    case `${BILL_APPROVAL_STEP_LIST}_FULFILLED`:
      return {
        ...state,
        approvalStepList: payload
      };

    case `${BILL_APPROVAL_STEP_LIST}_PENDING`:
      return {
        ...state,
        approvalStepList: payload
      };

    case `${BILL_APPROVAL_STEP_LIST}_REJECTED`:
      return {
        ...state,
        approvalStepList: payload
      };

    case `${BILL_APPROVAL_STEP_MOD}_FULFILLED`:
      return {
        ...state,
        approvalStepMod: payload
      };

    case `${BILL_APPROVAL_STEP_MOD}_PENDING`:
      return {
        ...state,
        approvalStepMod: payload
      };

    case `${BILL_APPROVAL_STEP_MOD}_REJECTED`:
      return {
        ...state,
        approvalStepMod: payload
      };

    case `${BILL_RETURN_STEP_MOD}_FULFILLED`:
      return {
        ...state,
        returnStepMod: payload
      };

    case `${BILL_RETURN_STEP_MOD}_PENDING`:
      return {
        ...state,
        returnStepMod: payload
      };

    case `${BILL_RETURN_STEP_MOD}_REJECTED`:
      return {
        ...state,
        returnStepMod: payload
      };

    case `${OURHOME_SUBTRACT_STATS_LIST}_FULFILLED`:
      return {
        ...state,
        ourhomeStatList: payload
      };
    // 사용 통계 초기화
    case INITIALIZE_USAGE_STATS:
      return {
        ...state,
        usageStats: null,
        usageStatsTotal: null
      };
    // 바코드 사용자 목록 조회
    case `${BARCODE_MEMBER}_PENDING`:
      return {
        ...state,
        barcodeMembers: payload
      };
    case `${BARCODE_MEMBER}_REJECTED`:
      return {
        ...state,
        barcodeMembers: payload
      };
    case `${BARCODE_MEMBER}_FULFILLED`:
      return {
        ...state,
        barcodeMembers: payload
      };
    // 바코드 히스토리
    case `${BARCODE_HISTORIES}_PENDING`:
      return {
        ...state,
        barcodeHistories: payload
      };
    case `${BARCODE_HISTORIES}_REJECTED`:
      return {
        ...state,
        barcodeHistories: payload
      };
    case `${BARCODE_HISTORIES}_FULFILLED`:
      return {
        ...state,
        barcodeHistories: payload
      };

    default:
      return state;
  }
}

export default usage;
